import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import React, { useEffect, useState, useContext, useRef } from "react";
import Context from "../context/context";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import ImageInput from '../components/ImageInput';

const category_update = {}

export default function AddNewItem({
  close,
  itemId,
  type,
  AllCategories,
  setCurrentMenu,
  Menu,
  setAvailableImages,
  availableImages
}) {

  // const server = 'http://localhost:5000'
  const server = 'https://api.myfooddo.com'

  const imageInputRef = useRef(null);
  const { bId } = useParams();
  const context = useContext(Context);
  const { updateUnSync, uploadImage, } = context;
  const [imageSRC, setImageSRC] = useState(availableImages?.[0] && availableImages?.includes(itemId) ? `${server}/item-images/${itemId}.webp` : null);

  const [dbMenu, setDbMenu] = useState({});
  const [itemDetails, setItemDetails] = useState({
    IDENTIFIER: "",
    category_uuid: AllCategories[0]?.category_uuid,
    item_mode: "0",
    item_name: "",
    item_uuid: "",
    outlet_wise_item_details: [
      {
        other_details: {
          item_availability: "1",
          item_code: "",
          item_description: "",
          item_excluded_from_charge: 0,
          item_excluded_from_discount: 0,
          item_gst: 0,
          item_kot_name: "",

          item_parcel_type: 2,
          item_status: 1,
          item_vat: 0,
        },
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      },
    ],
  });

  // Fetch all the available categories for a new item
  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );

      const indMenus = await db
        .transaction("menu", "readwrite")
        .objectStore("menu")
        .getAll();
      await setDbMenu(indMenus);

      // To edit item fetch item with (id) item_uuid
      if (type !== "New") {
        const indItems = await db
          .transaction("item", "readonly")
          .objectStore("item")
          .getAll();
        const currentItem = indItems.filter(
          (item) => item.item_uuid === itemId
        )[0];

        category_update.old_category = currentItem.category_uuid;
        console.log('stored old category', category_update.old_category)
        setItemDetails(currentItem);
      }
    };
    getDataFromIndexdDb();
  }, [bId, itemId, type]);

  // Adding new item to item collection in IndexedDB
  const handleSaveItem = async (e) => {
    e.preventDefault();
    const text = document.getElementById("item-name").value;
    if (text === "") return false;
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("item", "readwrite").objectStore("item");
    const id = uuid();
    const itemData = {
      IDENTIFIER: id,
      category_uuid: itemDetails.category_uuid,
      item_mode: itemDetails.item_mode,
      item_name: itemDetails.item_name,
      item_uuid: id,
      RECON_TIME: new Date().getTime().toString(),
      outlet_wise_item_details: [
        {
          other_details: {
            item_availability:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_availability,
            item_code:
              itemDetails.outlet_wise_item_details[0].other_details.item_code,
            item_description:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_description,
            item_excluded_from_charge:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_excluded_from_charge,
            item_excluded_from_discount:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_excluded_from_discount,
            item_gst:
              parseInt(
                itemDetails.outlet_wise_item_details[0].other_details.item_gst
              ) || 0,
            item_kot_name:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_kot_name,

            item_parcel_type:
              itemDetails.outlet_wise_item_details[0].other_details
                .item_parcel_type,
            item_status:
              itemDetails.outlet_wise_item_details[0].other_details.item_status,
            item_vat:
              parseInt(
                itemDetails.outlet_wise_item_details[0].other_details.item_vat
              ) || 0,
          },
          ...itemDetails.outlet_wise_item_details[0]
        },
      ],
    };

    const endFunction = async () => {
      await handleMenuEdit(itemData);
      await handleItemSaveUnsyncedFile(itemData);
      close();
    }

    await tx.add(
      Object.keys(itemData)
        .filter((key) => key !== "RECON_TIME")
        .reduce((obj, key) => {
          obj[key] = itemData[key];
          return obj;
        }, {})
    );

    if (imageSRC) {
      setAvailableImages && setAvailableImages([...availableImages, id]);
      uploadImage({
        image: imageInputRef.current.files[0],
        url: `${server}/upload/item-images/${id}/webp`,
        callback: endFunction
      })
    }
    else {
      await endFunction()
    }
  };

  // Editing existing item in item collection in IndexedDB
  const handleEditItem = async (e) => {
    e.preventDefault();
    const text = document.getElementById("item-name").value;
    if (text === "") {
      return false;
    }

    if (imageSRC) {
      uploadImage({
        image: imageInputRef.current.files[0],
        url: `${server}/upload/item-images/${itemId}/webp`,
        callback: () => setAvailableImages && setAvailableImages([...availableImages, itemId])
      })
    }

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = await db.transaction("item", "readwrite").objectStore("item");
    const data = {
      ...itemDetails,
      RECON_TIME: new Date().getTime().toString(),
    };

    console.log(`category in item json : ${itemDetails?.category_uuid}`)
    await tx.put(itemDetails);

    console.log("new_category", category_update.new_category, "old_category", category_update.old_category)

    if (category_update.new_category && category_update.new_category !== category_update.old_category) {

      const RECON_TIME = new Date().getTime().toString()
      dbMenu?.forEach(async menu_obj => {

        if (
          !menu_obj?.category_and_items?.find(cat => cat.category_uuid === category_update.old_category)
          && !menu_obj?.category_and_items?.find(cat => cat.category_uuid === category_update.new_category)
        )
          return console.log("Don't need to update this menu : ", menu_obj.menu_uuid)

        console.log('Current Menu : ', menu_obj)
        if (menu_obj?.menu_uuid === Menu?.menu_uuid) menu_obj = { ...Menu }

        const menu_item_copy = await menu_obj?.category_and_items
          ?.find(cat => cat.category_uuid === category_update.old_category)?.menu_items
          ?.find(i => i.item_uuid === itemDetails.item_uuid)

        console.log("Menu Item Copy : ", menu_item_copy)
        if (!menu_item_copy) return console.log('Item does not exists in this : ', menu_obj.menu_uuid)

        const updated_menu = await {
          ...menu_obj,
          category_and_items: menu_obj.category_and_items.map(cat => {

            if (cat.category_uuid === category_update.old_category)
              return {
                ...cat, menu_items: cat.menu_items.filter(i => i.item_uuid !== itemDetails.item_uuid)
              }

            else if (cat.category_uuid === category_update.new_category)
              return {
                ...cat, menu_items: [...cat.menu_items, menu_item_copy]
              }

            else
              return cat
          })
        }

        console.log('updated menu : ', updated_menu)
        tx = db.transaction("menu", "readwrite").objectStore("menu");
        await tx.put(updated_menu);

        console.log({ updated_menu: updated_menu?.menu_uuid, Menu: Menu })
        if (updated_menu?.menu_uuid === Menu?.menu_uuid) setCurrentMenu({ ...updated_menu })
        handleMenuUnsyncedFile({ ...updated_menu, RECON_TIME });
      })
    }

    await handleItemEditUnsyncedFile(data);
    close();
  };

  // Add new item to current menu to selected category in menu.category_and_items[].menu_items collection
  const handleMenuEdit = async (data) => {
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("menu", "readwrite").objectStore("menu");
    let currentMenues = await tx.getAll();
    let RECON_TIME = new Date().getTime().toString();

    currentMenues.filter((menuWithSameBrandId) => menuWithSameBrandId.brand_uuid === bId).forEach((menu) => {
      const doNotUpdateCat = menu.category_and_items.filter(cat => cat.category_uuid !== itemDetails.category_uuid);
      menu.category_and_items.filter(cat => cat.category_uuid === itemDetails.category_uuid).forEach(cat => {

        const lastIndex = cat.menu_items.length > 0 ? cat.menu_items.length - 1 : 0;
        const sortOrder = cat.menu_items[lastIndex]?.menu_item_sort_order
          ? parseInt(cat.menu_items[lastIndex]?.menu_item_sort_order) + 1
          : 1;

        const itemData = {
          item_uuid: data.item_uuid,
          menu_item_addons: [],
          menu_item_description: data.outlet_wise_item_details[0].other_details.item_description,
          menu_item_discount: "0",
          menu_item_label: "",
          menu_item_multi: [],
          menu_item_price: "0",
          menu_item_recommended: "N",
          menu_item_sort_order: String(sortOrder),
          menu_item_status: "1",
          menu_item_uuid: 12345678,
        };

        const categoryData = {
          category_uuid: cat.category_uuid,
          menu_category_sort_order: cat.menu_category_sort_order,
          menu_items: [...cat.menu_items, itemData],
        };

        let updatedMenu = {
          ...menu,
          category_and_items: [
            ...doNotUpdateCat,
            {
              category_uuid: categoryData.category_uuid,
              menu_category_sort_order: categoryData.menu_category_sort_order,
              menu_items: [...categoryData.menu_items],
            },
          ],
        };

        console.log('menu item ------------------------------------------')
        if (Menu?.menu_uuid === menu.menu_uuid)
          setCurrentMenu(curr => ({
            ...curr,
            category_and_items: curr?.category_and_items?.map(c => {
              if (c.category_uuid === cat.category_uuid) return { ...c, menu_items: [...c.menu_items, itemData] }
              else return c
            })
          }))

        tx = db.transaction("menu", "readwrite").objectStore("menu");
        tx.put(updatedMenu);
        handleMenuUnsyncedFile({ ...updatedMenu, RECON_TIME });
      });
    });
  };

  // Adding new added item to unsynced_files collection in IndexedDB
  const handleItemSaveUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: data.RECON_TIME,
      IDENTIFIER: "item-new:" + data.item_uuid,
    };
    await tx.put(ndata);
    handleItemReconciliation(ndata);
    updateUnSync()
  };

  // Editing item in unsynced_files collection in IndexedDB
  const handleItemEditUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const allUnsyncedFiles = await tx.getAll();
    const ndata = {
      ...data,
      RECON_TIME: data.RECON_TIME,
      IDENTIFIER: "item-edit:" + data.item_uuid,
    };
    const currentUnsyncedFile = allUnsyncedFiles.find(
      (curr) => curr.IDENTIFIER === "item-edit:" + data.item_uuid
    );
    currentUnsyncedFile ? await tx.put(ndata) : await tx.add(ndata);

    handleItemReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing item to reconciliation collection in IndexedDB
  const handleItemReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const itemsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "item"
    );
    if (itemsJsonExists) {
      const items = itemsJsonExists?.details?.filter(
        (item) => item.item_uuid !== data.item_uuid
      );
      const editData = {
        ...itemsJsonExists,
        details: [
          ...items,
          {
            item_uuid: data.item_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "item",
        details: [
          {
            item_uuid: data.item_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  // Adding/Editing new item added to menu in unsynced_files collection in IndexedDB
  const handleMenuUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const allUnsyncedFiles = await tx.getAll();
    const ndata = {
      ...data,

      IDENTIFIER: "menu-edit:" + data.menu_uuid,
    };
    let currentUnsyncedFile = allUnsyncedFiles.find(
      (curr) => curr.IDENTIFIER === "menu-edit:" + data.menu_uuid
    );
    currentUnsyncedFile ? await tx.put(ndata) : await tx.add(ndata);

    handleMenuReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const menusJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "menu"
    );
    if (menusJsonExists) {
      const menus = menusJsonExists?.details?.filter(
        (menu) => menu.menu_uuid !== data.menu_uuid
      );
      const editData = {
        ...menusJsonExists,
        details: [
          ...menus,
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  return (
    <div
      className='newCategory'
      onKeyDown={(e) =>
        e.key === "Enter" && itemDetails.item_name !== ""
          ? type === "New"
            ? handleSaveItem()
            : handleEditItem()
          : document.getElementById("catname").focus()
      }>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Item</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <form className='newCatContainer2'>
          <div className='debox'>
            <h1>General Details</h1>
            <div className='gen-box-in'>
              <div className='item-box-inp'>
                <label htmlFor='item-name'>Item Name</label>
                <input
                  id='item-name'
                  type='text'
                  maxLength={42}
                  required
                  value={itemDetails.item_name}
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      item_name: e.target.value,
                    })
                  }
                />
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-category'>Select Category</label>
                <select
                  id='item-category'
                  value={itemDetails.category_uuid}
                  onChange={(e) => {
                    setItemDetails({
                      ...itemDetails,
                      category_uuid: e.target.value,
                    })
                    category_update.new_category = e.target.value
                    console.log('Stored new Category : ', category_update.new_category)
                  }}>
                  {AllCategories?.map((section, i) => (
                    <option key={i} value={section.category_uuid}>
                      {section.category_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-mode'>Select Mode</label>
                <select
                  id='item-mode'
                  value={itemDetails.item_mode}
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      item_mode: e.target.value,
                    })
                  }>
                  <option value='0'>None</option>
                  <option value='1'>Veg</option>
                  <option value='2'>Non-Veg</option>
                </select>
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-code'>Item Code</label>
                <input
                  id='item-code'
                  maxLength={25}
                  type='text'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_code
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_code: e.target.value,
                          },
                        },
                      ],
                    })
                  }
                />
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-kot'>Name on Kot</label>
                <input
                  id='item-kot'
                  maxLength={42}
                  type='text'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_kot_name
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_kot_name: e.target.value,
                          },
                        },
                      ],
                    })
                  }
                />
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-desc'>Item Description</label>
                <input
                  id='item-desc'
                  maxLength={140}
                  type='text'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_description
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_description: e.target.value,
                          },
                        },
                      ],
                    })
                  }
                />
              </div>
            </div>

            <ImageInput
              lableText={'Item Image'}
              imageSRC={imageSRC}
              setImageSRC={setImageSRC}
              imageInputRef={imageInputRef}
              classList={{}}
              URLs={{ delete: `${server}/delete/item-images/${itemId}.webp` }}
            />

          </div>
          <div className='debox'>
            <h1>Tax Details</h1>
            <div className='gen-box-in'>
              <div className='item-box-inp'>
                <label htmlFor='item-gst'>GST</label>
                <input
                  id='item-gst'
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 3))}
                  type='number'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_gst
                  }
                  min={0}
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_gst: e.target.value,
                          },
                        },
                      ],
                    })
                  }
                />
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-vat'>VAT</label>
                <input
                  type='number'
                  id='item-vat'
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 3))}
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_vat
                  }
                  min={0}
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_vat: e.target.value,
                          },
                        },
                      ],
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className='otherdetails debox'>
            <h1>Other Details</h1>
            <div className='gen-box-in'>
              <div className='item-box-inp'>
                <label htmlFor='item-gst'>Exclude From Discount</label>
                <select
                  id='item-mode'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_excluded_from_discount
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_excluded_from_discount: e.target.value,
                          },
                        },
                      ],
                    })
                  }>
                  <option value='0'>Don`t Exclude</option>
                  <option value='1'>Yes, Exclude</option>
                </select>
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-efc'>Exclude From Charge</label>
                <select
                  id='item-efc'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_excluded_from_charge
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_excluded_from_charge: e.target.value,
                          },
                        },
                      ],
                    })
                  }>
                  <option value='0'>Don`t Exclude</option>
                  <option value='1'>Yes, Exclude</option>
                </select>
              </div>
              <div className='item-box-inp'>
                <label htmlFor='item-parcelmode'>Parcel Type</label>
                <select
                  id='item-parcelmode'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_parcel_type
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_parcel_type: e.target.value,
                          },
                        },
                      ],
                    })
                  }>
                  <option value='2'>Per Unit</option>
                  <option value='1'>Lumpsum</option>
                </select>
              </div>

              <div className='item-box-inp'>
                <label htmlFor='item-status'>Item Status</label>
                <select
                  id='item-status'
                  value={
                    itemDetails.outlet_wise_item_details[0].other_details
                      .item_status
                  }
                  onChange={(e) =>
                    setItemDetails({
                      ...itemDetails,
                      outlet_wise_item_details: [
                        {
                          ...itemDetails.outlet_wise_item_details[0],
                          other_details: {
                            ...itemDetails.outlet_wise_item_details[0]
                              .other_details,
                            item_status: e.target.value,
                          },
                        },
                      ],
                    })
                  }>
                  <option value='1'>Enabled</option>
                  <option value='0'>Disabled</option>
                </select>
              </div>
            </div>
          </div>

          {type === "New" ? (
            <button onClick={itemDetails.item_name ? handleSaveItem : console.log(itemDetails)}>
              Save
            </button>
          ) : (
            <button onClick={itemDetails.item_name ? handleEditItem : ""}>
              Update
            </button>
          )}
        </form>
      </div>
    </div>
  );
}